import type { ThemePreset } from "../types";

export const slate: ThemePreset = {
  id: "slate",
  name: "Schiefer",
  nameKey: "admin.settings.appearance.themes.slate.name",
  description: "Minimalistisches Grau",
  descriptionKey: "admin.settings.appearance.themes.slate.description",
  light: {
    background: "oklch(0.985 0.003 260)",
    foreground: "oklch(0.15 0.01 260)",
    card: "oklch(1 0 0)",
    "card-foreground": "oklch(0.15 0.01 260)",
    popover: "oklch(1 0 0)",
    "popover-foreground": "oklch(0.15 0.01 260)",
    primary: "oklch(0.45 0.02 260)",
    "primary-foreground": "oklch(0.985 0 0)",
    secondary: "oklch(0.95 0.005 260)",
    "secondary-foreground": "oklch(0.22 0.01 260)",
    muted: "oklch(0.95 0.004 260)",
    "muted-foreground": "oklch(0.50 0.01 260)",
    accent: "oklch(0.93 0.006 260)",
    "accent-foreground": "oklch(0.22 0.01 260)",
    destructive: "oklch(0.577 0.245 27.325)",
    "destructive-foreground": "oklch(0.985 0 0)",
    border: "oklch(0.91 0.005 260)",
    input: "oklch(0.91 0.005 260)",
    ring: "oklch(0.45 0.02 260)",
    "sidebar-background": "oklch(0.97 0.004 260)",
    "sidebar-foreground": "oklch(0.30 0.01 260)",
    "sidebar-primary": "oklch(0.45 0.02 260)",
    "sidebar-primary-foreground": "oklch(0.985 0 0)",
    "sidebar-accent": "oklch(0.93 0.005 260)",
    "sidebar-accent-foreground": "oklch(0.22 0.01 260)",
    "sidebar-border": "oklch(0.91 0.005 260)",
    "sidebar-ring": "oklch(0.45 0.02 260)",
  },
  dark: {
    background: "oklch(0.16 0.01 260)",
    foreground: "oklch(0.92 0.005 260)",
    card: "oklch(0.19 0.01 260)",
    "card-foreground": "oklch(0.92 0.005 260)",
    popover: "oklch(0.19 0.01 260)",
    "popover-foreground": "oklch(0.92 0.005 260)",
    primary: "oklch(0.65 0.02 260)",
    "primary-foreground": "oklch(0.15 0.01 260)",
    secondary: "oklch(0.24 0.01 260)",
    "secondary-foreground": "oklch(0.90 0.005 260)",
    muted: "oklch(0.24 0.008 260)",
    "muted-foreground": "oklch(0.62 0.01 260)",
    accent: "oklch(0.27 0.01 260)",
    "accent-foreground": "oklch(0.92 0.005 260)",
    destructive: "oklch(0.55 0.22 27)",
    "destructive-foreground": "oklch(0.98 0 0)",
    border: "oklch(0.30 0.01 260)",
    input: "oklch(0.30 0.01 260)",
    ring: "oklch(0.65 0.02 260)",
    "sidebar-background": "oklch(0.13 0.01 260)",
    "sidebar-foreground": "oklch(0.80 0.008 260)",
    "sidebar-primary": "oklch(0.65 0.02 260)",
    "sidebar-primary-foreground": "oklch(0.15 0.01 260)",
    "sidebar-accent": "oklch(0.21 0.01 260)",
    "sidebar-accent-foreground": "oklch(0.92 0.005 260)",
    "sidebar-border": "oklch(0.27 0.01 260)",
    "sidebar-ring": "oklch(0.65 0.02 260)",
  },
};
